/**
 * Class names for the shared form-field skin defined in `styles/global.css`.
 * Portalled popups can't be reached by a page-scoped selector, so a dropdown
 * opts in by class — from any feature, hence this lives outside one.
 */

/** A dropdown's popup panel: Radix `SelectContent`, or `contentClassName` on
 * `SearchableCombobox` / `TimezoneSelect`. */
export const FIELD_MENU_CLASS = 'field-menu';

/** A scope whose text inputs and dropdown triggers take the field LOOK — white
 * fill, `--ink-200` border, 9px radius, brand border + soft ring on focus in
 * place of the primitives' offset ring — without a fixed height, so each
 * control keeps its own size. Named for its first user, the Settings page. */
export const FIELD_LOOK_SCOPE_CLASS = 'settings-fields';
